import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Typography, Paper, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Chip, Link, Button
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import StorageIcon from '@mui/icons-material/Storage';
import ApiIcon from '@mui/icons-material/Api';
import LanguageIcon from '@mui/icons-material/Language';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import GitHubIcon from '@mui/icons-material/GitHub';
import DatasetFreshnessTable from './DatasetFreshnessTable';

const dataInventory = [
  // People & Structure
  { dataset: "parliamentarians", records: 1877, source: "ParlWork API", sourceType: "api", url: "https://parlwork.aph.gov.au/api/v1/individuals", description: "All MPs and Senators since Federation", category: "People & Structure" },
  { dataset: "parliamentarian_photos", records: 1878, source: "APH Photo Archive", sourceType: "web", url: "https://www.aph.gov.au/", description: "Official portrait photographs", category: "People & Structure" },
  { dataset: "electorates", records: 219, source: "ParlWork API", sourceType: "api", url: "https://parlwork.aph.gov.au/api/v1/electorates", description: "Federal electoral divisions", category: "People & Structure" },
  { dataset: "electorate_maps", records: 1962, source: "AEC Boundary Data", sourceType: "web", url: "https://www.aec.gov.au/", description: "KML boundary files by year (1903-2024)", category: "People & Structure" },
  { dataset: "parties", records: 57, source: "ParlWork API", sourceType: "api", url: "https://parlwork.aph.gov.au/api/v1/parties", description: "Political party information", category: "People & Structure" },
  { dataset: "parliaments", records: 48, source: "ParlWork API", sourceType: "api", url: "https://parlwork.aph.gov.au/api/v1/parliaments", description: "Parliament sessions 1st-48th", category: "People & Structure" },
  { dataset: "committees", records: 465, source: "ParlWork API", sourceType: "api", url: "https://parlwork.aph.gov.au/api/v1/committees", description: "Parliamentary committees", category: "People & Structure" },
  { dataset: "ministries", records: 75, source: "ParlWork API", sourceType: "api", url: "https://parlwork.aph.gov.au/api/v1/ministries", description: "Government ministries", category: "People & Structure" },
  { dataset: "ministryrecords", records: 5318, source: "ParlWork API", sourceType: "api", url: "https://parlwork.aph.gov.au/api/v1/ministryrecords", description: "Ministry appointment records", category: "People & Structure" },
  { dataset: "shadowministries", records: 47, source: "ParlWork API", sourceType: "api", url: "https://parlwork.aph.gov.au/api/v1/shadowministries", description: "Opposition shadow ministries", category: "People & Structure" },
  { dataset: "shadowministryrecords", records: 3167, source: "ParlWork API", sourceType: "api", url: "https://parlwork.aph.gov.au/api/v1/shadowministryrecords", description: "Shadow ministry appointments", category: "People & Structure" },
  { dataset: "recordsofservice", records: 59248, source: "ParlWork API", sourceType: "api", url: "https://parlwork.aph.gov.au/api/v1/recordsofservice", description: "Parliamentarian service history", category: "People & Structure" },

  // Chamber Documents
  { dataset: "bills", records: 2240, source: "ParlWork API", sourceType: "api", url: "https://parlwork.aph.gov.au/api/bills", description: "Legislation bills", category: "Chamber Documents" },
  { dataset: "notice_papers", records: 2944, source: "APH Website", sourceType: "web", url: "https://www.aph.gov.au/Parliamentary_Business/Chamber_documents/", description: "House & Senate notice papers", category: "Chamber Documents" },
  { dataset: "standing_orders", records: 1020, source: "APH PDF", sourceType: "pdf", url: "https://www.aph.gov.au/About_Parliament/House_of_Representatives/Powers_practice_and_procedure/House_of_Representatives_Standing_Orders", description: "House of Representatives standing orders", category: "Chamber Documents" },
  { dataset: "senate_standing_orders", records: 212, source: "APH PDF", sourceType: "pdf", url: "https://www.aph.gov.au/Parliamentary_Business/Chamber_documents/Senate_Procedural_Documents", description: "Senate standing orders", category: "Chamber Documents" },
  { dataset: "motions", records: 31, source: "APH Website", sourceType: "web", url: "https://www.aph.gov.au/Parliamentary_Business/Chamber_documents/", description: "Notices of motion", category: "Chamber Documents" },
  { dataset: "house_practice", records: 21, source: "APH PDF", sourceType: "pdf", url: "https://www.aph.gov.au/About_Parliament/House_of_Representatives/Powers_practice_and_procedure/Practice7", description: "House of Representatives Practice (7th ed)", category: "Chamber Documents" },
  { dataset: "parliament_calendar", records: 4449, source: "APH Calendar", sourceType: "web", url: "https://www.aph.gov.au/About_Parliament/Sitting_Calendar", description: "Sitting calendar and events", category: "Chamber Documents" },

  // Chamber Records
  { dataset: "hansard", records: 9017, source: "ParlInfo XML", sourceType: "api", url: "https://parlinfo.aph.gov.au/", description: "Recent Hansard transcripts (2011-present)", category: "Chamber Records" },
  { dataset: "hansard_historic", records: 498153, source: "Historic Hansard Project", sourceType: "github", url: "https://github.com/wragge/hansard-data", description: "Digitised Hansard 1901-1980", category: "Chamber Records" },
  { dataset: "votes_proceedings", records: 100, source: "APH PDF", sourceType: "pdf", url: "https://www.aph.gov.au/Parliamentary_Business/Chamber_documents/HoR_Votes_and_Proceedings", description: "House Votes and Proceedings", category: "Chamber Records" },
  { dataset: "senate_journals", records: 100, source: "APH PDF", sourceType: "pdf", url: "https://www.aph.gov.au/Parliamentary_Business/Chamber_documents/Senate_Journals", description: "Senate Journals", category: "Chamber Records" },
  { dataset: "hor_divisions", records: 131, source: "APH Website", sourceType: "web", url: "https://www.aph.gov.au/Parliamentary_Business/Statistics/", description: "House of Representatives division votes", category: "Chamber Records" },
  { dataset: "senate_divisions", records: 6387, source: "APH Website", sourceType: "web", url: "https://www.aph.gov.au/Parliamentary_Business/Statistics/Senate_Divisions", description: "Senate division votes", category: "Chamber Records" },
  { dataset: "house_daily_program", records: 694, source: "APH Website", sourceType: "web", url: "https://www.aph.gov.au/Parliamentary_Business/Chamber_documents/", description: "House daily sitting programs", category: "Chamber Records" },
  { dataset: "senate_order_of_business", records: 881, source: "APH Website", sourceType: "web", url: "https://www.aph.gov.au/Parliamentary_Business/Chamber_documents/", description: "Senate order of business", category: "Chamber Records" },
  { dataset: "tabled_documents", records: 34258, source: "ParlInfo Search", sourceType: "api", url: "https://parlinfo.aph.gov.au/", description: "Tabled papers and documents", category: "Chamber Records" },

  // Questions
  { dataset: "questions_on_notice", records: 1975, source: "APH Estimates", sourceType: "web", url: "https://www.aph.gov.au/Parliamentary_Business/Senate_Estimates", description: "Senate Estimates Questions on Notice", category: "Questions" },
  { dataset: "senate_qon", records: 100, source: "ParlWork API", sourceType: "api", url: "https://parlwork.aph.gov.au/api/senate/questions/search", description: "Senate Questions on Notice", category: "Questions" },
  { dataset: "house_qiw", records: 134, source: "ParlWork API", sourceType: "api", url: "https://parlwork.aph.gov.au/api/house/questions/search", description: "House Questions in Writing", category: "Questions" },

  // Committee Reports
  { dataset: "committee_reports", records: 63249, source: "ParlInfo Search", sourceType: "api", url: "https://parlinfo.aph.gov.au/", description: "Committee reports with extracted PDF content", category: "Committee Reports" },

  // Petitions
  { dataset: "petitions", records: 5055, source: "APH e-Petitions API", sourceType: "api", url: "https://epetitions.aph.gov.au/api/", description: "E-petitions and paper petitions (2016-present)", category: "Petitions" },

  // Reference Documents
  { dataset: "constitution", records: 145, source: "APH PDF", sourceType: "pdf", url: "https://www.aph.gov.au/About_Parliament/Senate/Powers_practice_n_procedures/Constitution", description: "Australian Constitution sections", category: "Reference" },
];

const sourceTypeIcons = {
  api: <ApiIcon fontSize="small" />,
  web: <LanguageIcon fontSize="small" />,
  pdf: <PictureAsPdfIcon fontSize="small" />,
  github: <GitHubIcon fontSize="small" />
};

const sourceTypeColors = {
  api: "primary",
  web: "secondary",
  pdf: "error",
  github: "default"
};

const categoryColors = {
  "People & Structure": "#1976d2",
  "Chamber Documents": "#388e3c",
  "Chamber Records": "#f57c00",
  "Questions": "#7b1fa2",
  "Committee Reports": "#c62828",
  "Petitions": "#00838f",
  "Reference": "#5d4037"
};

export default function DataSources() {
  const navigate = useNavigate();

  const totalRecords = dataInventory.reduce((sum, item) => sum + item.records, 0);
  const categories = [...new Set(dataInventory.map(item => item.category))];

  const categoryTotals = categories.map(cat => ({
    name: cat,
    count: dataInventory.filter(item => item.category === cat).reduce((sum, item) => sum + item.records, 0),
    datasets: dataInventory.filter(item => item.category === cat).length
  }));

  return (
    <Box sx={{ p: 3 }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate('/help')}
        sx={{ mb: 2 }}
      >
        Back to Help
      </Button>

      <Typography variant="h4" sx={{ mb: 1 }}>
        <StorageIcon sx={{ mr: 1, verticalAlign: 'bottom' }} />
        Data Sources
      </Typography>

      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        ParlSearch aggregates data from multiple official Australian Parliament sources.
        All data is sourced from publicly available government websites and APIs.
      </Typography>

      {/* Summary Stats */}
      <Paper sx={{ p: 3, mb: 3, bgcolor: '#f5f5f5' }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          Summary
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3 }}>
          <Box>
            <Typography variant="h4" color="primary" sx={{ fontWeight: 700 }}>
              {totalRecords.toLocaleString()}
            </Typography>
            <Typography variant="body2" color="text.secondary">Total Records</Typography>
          </Box>
          <Box>
            <Typography variant="h4" color="secondary" sx={{ fontWeight: 700 }}>
              {dataInventory.length}
            </Typography>
            <Typography variant="body2" color="text.secondary">Datasets</Typography>
          </Box>
          <Box>
            <Typography variant="h4" sx={{ fontWeight: 700, color: '#388e3c' }}>
              {categories.length}
            </Typography>
            <Typography variant="body2" color="text.secondary">Categories</Typography>
          </Box>
        </Box>
      </Paper>

      {/* Dataset freshness (data-driven from /api/data-sources/freshness) */}
      <DatasetFreshnessTable />

      {/* Category Breakdown */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          By Category
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {categoryTotals.map(cat => (
            <Chip
              key={cat.name}
              label={`${cat.name}: ${cat.count.toLocaleString()} records (${cat.datasets} datasets)`}
              sx={{
                bgcolor: categoryColors[cat.name],
                color: 'white',
                fontWeight: 500
              }}
            />
          ))}
        </Box>
      </Paper>

      {/* Main Data Table */}
      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          Complete Data Inventory
        </Typography>

        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                <TableCell sx={{ fontWeight: 600 }}>Dataset</TableCell>
                <TableCell sx={{ fontWeight: 600 }} align="right">Records</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Source</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Type</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Description</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Category</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dataInventory.map((row) => (
                <TableRow key={row.dataset} hover>
                  <TableCell>
                    <code style={{ fontSize: '0.85rem', backgroundColor: '#f5f5f5', padding: '2px 6px', borderRadius: '4px' }}>
                      {row.dataset}
                    </code>
                  </TableCell>
                  <TableCell align="right">
                    <strong>{row.records.toLocaleString()}</strong>
                  </TableCell>
                  <TableCell>
                    <Link
                      href={row.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{ fontSize: '0.85rem' }}
                    >
                      {row.source}
                    </Link>
                  </TableCell>
                  <TableCell>
                    <Chip
                      icon={sourceTypeIcons[row.sourceType]}
                      label={row.sourceType.charAt(0).toUpperCase() + row.sourceType.slice(1)}
                      size="small"
                      color={sourceTypeColors[row.sourceType]}
                      variant="outlined"
                    />
                  </TableCell>
                  <TableCell sx={{ fontSize: '0.85rem' }}>
                    {row.description}
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={row.category}
                      size="small"
                      sx={{
                        bgcolor: categoryColors[row.category],
                        color: 'white',
                        fontSize: '0.7rem'
                      }}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* Source Types Legend */}
      <Paper sx={{ p: 3, mt: 3 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          Source Types
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Chip icon={<ApiIcon />} label="API" size="small" color="primary" variant="outlined" />
            <Typography variant="body2">Official Parliament APIs (ParlWork, ParlInfo, e-Petitions)</Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Chip icon={<LanguageIcon />} label="WEB" size="small" color="secondary" variant="outlined" />
            <Typography variant="body2">Scraped from APH website pages</Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Chip icon={<PictureAsPdfIcon />} label="PDF" size="small" color="error" variant="outlined" />
            <Typography variant="body2">Extracted from official PDF documents</Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Chip icon={<GitHubIcon />} label="GITHUB" size="small" variant="outlined" />
            <Typography variant="body2">Open source projects (Historic Hansard by Tim Sherratt)</Typography>
          </Box>
        </Box>
      </Paper>

      {/* Attribution */}
      <Paper sx={{ p: 3, mt: 3, bgcolor: '#fff3e0' }}>
        <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
          Data Attribution
        </Typography>
        <Typography variant="body2" paragraph>
          All parliamentary data is sourced from the Parliament of Australia and is used under the
          Creative Commons Attribution-NonCommercial-NoDerivs 3.0 Australia licence where applicable.
        </Typography>
        <Typography variant="body2" paragraph>
          Historic Hansard data (1901-1980) is sourced from the <Link href="https://github.com/wragge/hansard-data" target="_blank">Historic Hansard project</Link> by
          Tim Sherratt, which digitised and structured historical parliamentary debates.
        </Typography>
        <Typography variant="body2">
          Electoral boundary data is sourced from the Australian Electoral Commission (AEC).
        </Typography>
      </Paper>
    </Box>
  );
}
